import httpLocal from '../utils/http-local'

export const getPrinters = (host, cancelToken) => {
  return httpLocal.get('/printers', { baseURL: host, cancelToken: cancelToken?.token })
}

export const print = (data, host) => {
  return httpLocal.post('/printers/print', data, { baseURL: host })
}

export const getScales = (cancelToken) => {
  return httpLocal.get('/scales/scales', { cancelToken: cancelToken?.token })
}

export const getWeight = () => {
  return httpLocal.get('/scales/weight')
}

export const setAutoPrint = (data) => {
  return httpLocal.post('/scales/setAutoPrint', data)
}

export const getDevices = (host, cancelToken) => {
  return httpLocal.get('/settings', { baseURL: host, cancelToken: cancelToken?.token })
}

export const setDevice = (data, host) => {
  return httpLocal.post('/settings', data, { baseURL: host })
}

const PrintDataService = {
  getPrinters,
  print,
  getScales,
  getWeight,
  setAutoPrint,
  getDevices,
  setDevice,
}

export default PrintDataService
